module.exports = __webpack_public_path__ + "img/nt127-05-81-1.prt.4c632e29.jpg";